import React from 'react';

import { DescriptiveTags } from '@r6digital/rapidstor-types/types/Descriptor';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './styles.module.scss';

interface Props {
    tags: DescriptiveTags[];
    secondary?: boolean;
    tertiary?: boolean;
    wizard?: boolean;
}

const solidIconsByName = Object.fromEntries(
    Object.values(fas).map((icon) => [icon.iconName, icon]),
);
// "image-user" was the old fixed picker's id for this icon - not a real FontAwesome name.
solidIconsByName['image-user'] = solidIconsByName.user;

export default function DescriptorTag({
    tags, secondary, tertiary, wizard,
}: Props) {
    const getIcon = (name: string) => solidIconsByName[name];

    return (
        <div
            className={`${wizard && classes.wizard} ${classes.tags} ${
                [
                    wizard ? classes.wizard : '',
                    classes.tags,
                    secondary ? classes.secondary : '',
                    tertiary ? classes.tertiary : '',
                    !secondary && !tertiary ? classes.primary : '',
                ].join(' ').trim()
            }`}
        >
            {tags && tags.map((tag, index) => {
                if (tag.enabled) {
                    return (
                        <div key={`${tag.icon}_${index}_idx`} className={`${tag.icon}_${index}_idx`}>
                            <FontAwesomeIcon size="lg" icon={getIcon(tag.icon)} />
                            <span>{tag.content}</span>
                        </div>
                    );
                }

                return null;
            })}
        </div>
    );
}
